import React, { HTMLAttributes } from 'react';
import styles from './TwoColumnGrid.module.css';

interface TwoColumnGridProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const TwoColumnGrid: React.FC<TwoColumnGridProps> = ({ children, className = '', ...rest }) => {
  const classes = [styles.grid, className].filter(Boolean).join(' ');

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
};

export default TwoColumnGrid;